import{schemaAbiTypeToDefaultValue as i}from"@latticexyz/schema-type";function c(e){return Object.fromEntries(Object.entries(e).map(([m,a])=>[m,i[a]]))}export{c as a};
//# sourceMappingURL=chunk-4XPD3J6Y.js.map